import { render, staticRenderFns } from "./PlannerSetting.vue?vue&type=template&id=60fa1cbc&"
import script from "./PlannerSetting.vue?vue&type=script&lang=ts&"
export * from "./PlannerSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports